module.exports = __webpack_public_path__ + "static/img/forward.7500b4c8.svg";